import { z } from 'zod';

export const referralSchema = z.discriminatedUnion('hasCode', [
  z.object({
    hasCode: z.literal('yes'),
    code: z
      .string({ required_error: 'Enter your referral code' })
      .trim()
      .min(1, 'Enter your referral code')
      .max(32, 'Referral code is too long')
      .transform((v) => v.toUpperCase()),
  }),
  z.object({
    hasCode: z.literal('no'),
  }),
]);

export type Referral = z.infer<typeof referralSchema>;
